import React, { FC, useEffect }     from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table }                    from "semantic-ui-react";
import GetMailTemplates             from "../../../../../application/usecase/mail/template/GetMailTemplates";
import MailTemplate                 from "../../../../../domain/mail/template/MailTemplate";
import MailTemplates                from "../../../../../domain/mail/template/MailTemplates";
import { ResKaState }               from "../../../../../index";
import BottomSection                from "../../../common/layout/BottomSection";
import ListTotalCount               from "../../../common/layout/ListTotalCount";
import MailTemplateDeleteButton     from "./MailTemplateDeleteButton";
import MailTemplatesPagination      from "./MailTemplatesPagination";
import MailTemplateUpdateFormButton from "./MailTemplateUpdateFormButton";

const MailTemplateList: FC = () => {
  const mailTemplates: MailTemplates = useSelector((state: ResKaState) => state.mailTemplates);
  const getMailTemplates: GetMailTemplates = new GetMailTemplates(useDispatch());

  useEffect(() => {
    getMailTemplates.execute(mailTemplates.pagination.current);
  }, []);

  if (mailTemplates.isEmpty()) {
    return <p>メール雛形がまだ作成されていません。</p>
  }

  return (
    <>
      <ListTotalCount>{ mailTemplates.count.toString() }</ListTotalCount>
      <Table
        striped
      >
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>
              メール雛形名称
            </Table.HeaderCell>
            <Table.HeaderCell>
              メール件名
            </Table.HeaderCell>
            <Table.HeaderCell>
              操作
            </Table.HeaderCell>
            <Table.HeaderCell>
              作成日
            </Table.HeaderCell>
            <Table.HeaderCell>
              更新日
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {
            mailTemplates.toList().map((mailTemplate: MailTemplate) => (
              <Table.Row>
                <Table.Cell>
                  { mailTemplate.name.value }
                </Table.Cell>
                <Table.Cell>
                  { mailTemplate.subject.value }
                </Table.Cell>
                <Table.Cell>
                  <MailTemplateUpdateFormButton mailTemplate={ mailTemplate }/>
                  <MailTemplateDeleteButton mailTemplate={ mailTemplate }/>
                </Table.Cell>
                <Table.Cell>
                  { mailTemplate.trail.createdAt.toString() }
                </Table.Cell>
                <Table.Cell>
                  { mailTemplate.trail.updatedAt.toString() }
                </Table.Cell>
              </Table.Row>
            ))
          }
        </Table.Body>
      </Table>

      <BottomSection>
        <MailTemplatesPagination/>
      </BottomSection>
    </>
  );
};

export default MailTemplateList;